<script setup lang="ts">
import { useBasketStore } from '@/store/basket/basket'

import type { AdditiveItem, Gift, Item } from '@/types/api/api-v3/basket'

import BasketOrderHeader from '@/components/Basket/basket-order/BasketOrderHeader.vue'
import BasketOrderList from '@/components/Basket/basket-order/BasketOrderList.vue'

const DialogBasketClear = defineAsyncComponent(
  () => import('@/components/Basket/dialogs/DialogBasketClear.vue'),
)

type Props = {
  items: Item[]
  giftsWithoutChoice: Gift[]
  additives: AdditiveItem[]
}

defineProps<Props>()

const basketStore = useBasketStore()

const isClearBasketDialogVisible = ref(false)

const clearBasket = async () => {
  window.carrotquest?.track('Корзина очищена', {})

  localStorage.setItem('showedWarningAdditivesOrClientPack', 'false')
  localStorage.removeItem('selectedGift')

  await basketStore.clearBasket()
}
</script>

<template>
  <section class="order">
    <basket-order-header
      @show-clear-basket-dialog="isClearBasketDialogVisible = true"
    />

    <basket-order-list
      :items="items"
      :gifts-without-choice="giftsWithoutChoice"
      :additives="additives"
      class="item-list"
    />

    <the-dialog v-model="isClearBasketDialogVisible" :max-width="620">
      <dialog-basket-clear
        @allow="clearBasket"
        @disallow="isClearBasketDialogVisible = false"
      />
    </the-dialog>
  </section>
</template>
